import { get } from 'lodash';
import {
  NEW_SURVEY_CREATE_UPDATE_SERVER_DELTA,
  SERVER_UPDATE_TIME,
} from '../constants/time';

export default survey => {
  const thumbnailUpdatedAt = Date.parse(get(survey, 'previewImage.updatedAt'));
  const surveyUpdatedAt = Date.parse(get(survey, 'updatedAt'));
  const surveyCreatedAt = Date.parse(get(survey, 'createdAt'));
  const isNew =
    surveyUpdatedAt - surveyCreatedAt < NEW_SURVEY_CREATE_UPDATE_SERVER_DELTA;

  if (isNew) {
    return false;
  }

  if (!thumbnailUpdatedAt) {
    return true;
  }

  return surveyUpdatedAt - thumbnailUpdatedAt > SERVER_UPDATE_TIME;
};
